import { Image } from '@change/ds-core-ui';

type ImpactImageProps = Readonly<{
	image: string;
	title: string;
	view: string;
}>;

export const ImpactImage: React.FC<ImpactImageProps> = ({ image, title, view }) => {
	return (
		<div
			className={view === 'mobile' ? 'md:hidden' : 'hidden md:block'}
			data-testid={`impact-story-image-${view}`}
			data-qa={`impact-story-image-${view}`}
		>
			<Image
				src={image}
				data-testid="impact-story-image"
				className="md:rounded-large h-full w-full rounded-none object-cover"
				alt={title}
			/>
		</div>
	);
};
